import { getConfig, Env, Service } from '@magicdoorinc/env';

export const allowNonProdDiagnostics = (): boolean => {
  if (import.meta.env.DEV) return true;
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname.toLowerCase();
  return hostname.includes('test') || hostname.includes('dev') || hostname.includes('staging');
};

export const getEnv = (): Env => {
  if (import.meta.env.DEV) {
    const viteEnv = import.meta.env.VITE_ENV;
    if (viteEnv) {
      return viteEnv as Env;
    }
    return Env.Test;
  }
  const hostname = window.location.hostname;
  if (hostname.includes('dev')) {
    return Env.Dev;
  }
  if (hostname.includes('test')) {
    return Env.Test;
  }
  if (hostname.includes('demo')) {
    return Env.Demo;
  }
  return Env.Production;
};

export const envConfig = getConfig(getEnv);

export const leasingServiceUrl = (): string => {
  const override = import.meta.env.VITE_LEASING_SERVICE_URL as string | undefined;
  if (override) return override.replace(/\/$/, '');
  return envConfig.service[Service.Leasing];
};

export const genieServiceUrl = (): string => {
  const override = import.meta.env.VITE_GENIE_SERVICE_URL as string | undefined;
  if (override) return override.replace(/\/$/, '');
  return envConfig.service[Service.Ai];
};

export const settingsServiceUrl = (): string => {
  const override = import.meta.env.VITE_SETTINGS_SERVICE_URL as string | undefined;
  if (override) return override.replace(/\/$/, '');
  return envConfig.service[Service.Settings];
};

export const companiesServiceUrl = (): string => {
  const override = import.meta.env.VITE_COMPANIES_SERVICE_URL as string | undefined;
  if (override) return override.replace(/\/$/, '');
  return envConfig.service[Service.Companies];
};

export const maintenanceServiceUrl = (): string => {
  const override = import.meta.env.VITE_MAINTENANCE_SERVICE_URL as string | undefined;
  if (override) return override.replace(/\/$/, '');
  return envConfig.service[Service.Maintenance];
};

export const hoaServiceUrl = (): string => {
  const override = import.meta.env.VITE_HOA_SERVICE_URL as string | undefined;
  if (override) return override.replace(/\/$/, '');
  return envConfig.service[Service.Hoa];
};

// @magicdoorinc/env 5.1.0 dropped the communications entry that 5.0.0 had, and there is no later
// version to move to. Every services-path URL shares one base, so the base comes from a service the
// package still lists and only the last segment differs.
export const communicationsServiceUrl = (): string => {
  const override = import.meta.env.VITE_COMMUNICATIONS_SERVICE_URL as string | undefined;
  if (override) return override.replace(/\/$/, '');
  return envConfig.service[Service.Settings].replace(/\/settings$/, '/communications');
};

export const authServiceUrl = (): string => {
  const override = import.meta.env.VITE_AUTH_SERVICE_URL as string | undefined;
  if (override) return override.replace(/\/$/, '');
  return envConfig.service[Service.Auth];
};
